import { Badge, Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";

type Props = {
  id: number;
};

export default function CourseOnlineStatus({ id }: Props) {
  const [data, setData] = useState<number | null>(null); // Mengubah tipe data menjadi number
  const [loading, setLoading] = useState<boolean>(false);
  const { trigger } = useTrigger();

  useEffect(() => {
    if (id) {
      setLoading(true);
      const url = `api/course/${id}/onlinestatus`;
      cr.get(url)
        .then((r) => {
          if (r.status === 200) {
            setData(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, trigger]);

  if (loading || data === null) {
    return (
      <Badge>
        <Spinner size={"xs"} mt={"3px"} />
      </Badge>
    );
  }

  return (
    <Badge colorScheme={data === 1 ? "green" : "red"}>
      {data === 1 ? "Online" : "Offline"}
    </Badge>
  );
}
